import React, { useEffect, useRef } from "react";

export default function CursorSpark() {
  const dot = useRef(null);
  const ring = useRef(null);
  useEffect(() => {
    let mx = -100, my = -100, rx = -100, ry = -100;
    let raf;
    const onMove = (e) => { mx = e.clientX; my = e.clientY; if (dot.current) { dot.current.style.transform = `translate(${mx}px, ${my}px)`; } };
    const loop = () => { rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12; if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px)`; raf = requestAnimationFrame(loop); };
    window.addEventListener("mousemove", onMove);
    loop();
    return () => { cancelAnimationFrame(raf); window.removeEventListener("mousemove", onMove); };
  }, []);
  return (
    <>
      <div ref={dot} style={{ position: "fixed", top: 0, left: 0, width: 6, height: 6, borderRadius: 999, background: "#f0a663", pointerEvents: "none", mixBlendMode: "screen", transform: "translate(-100px,-100px)", zIndex: 60, filter: "blur(0.4px)", boxShadow: "0 0 12px rgba(240,166,99,0.9)" }} />
      <div ref={ring} style={{ position: "fixed", top: -18, left: -18, width: 36, height: 36, borderRadius: 999, border: "1px solid rgba(240,166,99,0.35)", pointerEvents: "none", mixBlendMode: "screen", transform: "translate(-100px,-100px)", zIndex: 59, transition: "width .3s ease, height .3s ease" }} />
    </>
  );
}
